module.exports = __webpack_public_path__ + "static/img/theme_4.486a6065.png";